import { createContext, useContext } from 'react'
import type {
  ArtworkDetailFragment,
  ArtworkWithTaskDetailBaseFragment,
  DetailedTaskParameters,
  TackPreviewFragment,
} from '../../services/apollo/generated/graphql'
import type { TrackOptions } from '../../utils/tracker'
import { track } from '../../utils/tracker'
import type { ParsedParamsForArtworkDetail } from './ArtworkDetail/parser'

export interface ArtworkDetailProps {
  artwork: ArtworkDetailFragment
  artworkLoras: ArtworkWithTaskDetailBaseFragment['loras']
  taskParameters: ArtworkWithTaskDetailBaseFragment['taskParameters']

  isSinglePage?: boolean
  shouldExploreStyleTargetBlank?: boolean
  onClose?: () => any

  /**
   * Extra tracking handler
   * For `Rec` related tracking events
   */
  onLikeClickForRec?: () => void
  /**
   * For `normal` tracking events
   * Inherited from artwork list or artwork page
   */
  trackingArgs?: Record<string, any>
  refetchArtwork?: () => void

  /** For ArtworkLikeButton */
  oauthReturnOpensDetail?: boolean
}

export type ArtworkDetailContextType = Partial<ArtworkDetailProps> & {
  /**
   * @deprecated use parsedTaskParameters instead
   */
  taskParameters?: DetailedTaskParameters
  parsedTaskParameters?: ParsedParamsForArtworkDetail
  userIsAuthor?: boolean
}

export const ArtworkDetailContext = createContext<ArtworkDetailContextType>({})

export const useArtworkDetailContext = () => useContext(ArtworkDetailContext)

export type TrackableArtwork = Pick<
  ArtworkDetailFragment,
  'id' | 'authorId'
> & {
  tacks?: Array<
    Pick<TackPreviewFragment, 'id' | 'codeName' | 'defaultName'>
  > | null
}

export const trackArtwork = (
  event: string,
  artwork?: TrackableArtwork,
  extra?: Record<string, any>,
  options?: TrackOptions,
) => {
  track(
    event,
    {
      artworkId: artwork?.id,
      tags: artwork?.tacks?.map(({ codeName }) => codeName),
      tackIds: artwork?.tacks?.map(({ id }) => id),
      tackCodeNames: artwork?.tacks?.map(({ codeName }) => codeName),
      tackDefaultNames: artwork?.tacks?.map(({ defaultName }) => defaultName),
      authorId: artwork?.authorId,
      ...extra,
    },
    options,
  )
}
